import { CreditCardOutlined } from "@ant-design/icons";
import { Button, Space, theme, Tooltip, Typography } from "../ui";
import { useEffect, useState } from "react";
import type { AppShellAction } from "./AppShell";
import { appShellMetrics, spacing } from "./spacing";

/** A changed balance is briefly highlighted; the first loaded value stays quiet. */
export function AppShellCredits({ label, balance, hint, onClick, disabled, compact }: AppShellAction & { balance: string; hint?: string; compact: boolean }) {
  const { token } = theme.useToken();
  const [snapshot, setSnapshot] = useState({ balance, highlighted: false });
  if (snapshot.balance !== balance) {
    setSnapshot({ balance, highlighted: Boolean(snapshot.balance) });
  }
  useEffect(() => {
    if (!snapshot.highlighted) return;
    const timer = window.setTimeout(() => setSnapshot(current => current.balance === balance ? { ...current, highlighted: false } : current), appShellMetrics.creditHighlightMs);
    return () => window.clearTimeout(timer);
  }, [balance, snapshot.highlighted]);
  const description = [ `${label}: ${balance}`, hint ].filter(Boolean).join(". ");
  return (
    <div style={{ padding: spacing.tightGap }}>
    <Tooltip title={description}>
      <Button type="text" icon={<CreditCardOutlined />} aria-label={description} onClick={onClick} disabled={disabled} style={{ width: "100%", minHeight: appShellMetrics.creditBarHeight, height: !compact && hint ? "auto" : appShellMetrics.creditBarHeight, paddingBlock: !compact && hint ? spacing.tightGap : undefined, borderRadius: 0, justifyContent: compact ? "center" : "flex-start", paddingInline: compact ? 0 : appShellMetrics.navigationIndent - spacing.tightGap, borderTop: `1px solid ${token.colorSplit}` }}>
        {!compact ? <Space direction="vertical" size={0} style={{ minWidth: 0, textAlign: "left" }}>
          <Typography.Text type={snapshot.highlighted ? undefined : "secondary"} ellipsis style={{ transition: "color 0.4s ease", color: snapshot.highlighted ? token.colorPrimary : undefined }}>{balance}</Typography.Text>
          {hint ? <Typography.Text type="secondary" style={{ fontSize: token.fontSizeSM, whiteSpace: "normal" }}>{hint}</Typography.Text> : null}
        </Space> : null}
      </Button>
    </Tooltip>
    </div>
  );
}
